import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 0A3C9B3E-5A92-45A9-AE11-63B0512981FB
 * name arrow-bottom-right-bold-box
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-bottom-right-bold-box.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomRightBoldBoxIcon = createSvgIcon(<><path d="M19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21M15.8 16V8.9L13.7 11L9.8 7.2L7 10L10.8 13.9L8.7 16H15.8Z" /></>, 'ArrowBottomRightBoldBoxIcon');
export default ArrowBottomRightBoldBoxIcon